import React from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import {acurisButtonBackgroundColour} from "../../../style/styleConsts";
import {useDispatch, useSelector} from "react-redux";
import authorActions from "../homepage/authorActions";
import subscriptionActions from "../../subscription/subscriptionActions";
import {logAction} from "../../../logging/logEvent";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
`;

const modalStyle = {
    overlay: {
        background: "rgba(0,0,0,0.4)"
    },
    content: {
        position: 'absolute',
        top: "12px",
        left: "16px",
        right: "16px",
        bottom: '12px',
        overflow: 'visible',
        outline: 'none',
        padding: '0px',
        minHeight: '600px',
        border: `1px solid ${acurisButtonBackgroundColour}`,
        borderRadius: '4px',
        marginTop: '2px',
        marginBottom: '2px',
        marginLeft: '4px',
        marginRight: '4px',
    }
};

const Header = styled.div`
    display: flex;
    flex-grow: 0;
    height: 50px;
    justify-content: center;
    align-items: stretch;
    background-color: ${acurisButtonBackgroundColour};
`;

const Title = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
`;

const CloseButtonContainer = styled.div`
    width: 48px;
    flex-grow: 0;
    cursor: pointer;
`;

const XButton = styled.div`
    position: absolute;
    top: -4px;
    right: 12px;
    font-size: 36px;
    color: white;
`;

const CreateScreenIframe = styled.iframe`
    border: 0;
    flex-grow: 1;
    width: 100%;
    min-width: 500px;
    min-height: 500px;
    overflow: hidden;
`;

const CreateIdeaModal = ({}) => {
    const authorDetails = useSelector(state => state.authorDetails);
    const dispatch = useDispatch();

    const iframe = <CreateScreenIframe name="ui-revamp-iframe" src="/TradeIdeasMonitor/ui/index.html?TIM2#/home"/>;

    function doClose() {
        logAction({type: "CREATE_IDEA_SCREEN_CLOSED"});
        subscriptionActions(dispatch).kick("AUTHOR_HOMEPAGE");
        subscriptionActions(dispatch).kick("PORTFOLIO_AUTHOR");
        authorActions(dispatch).hideCreateScreen();
    }

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={authorDetails.createModalVisible}
            onRequestClose={doClose}
            contentLabel="Create Idea"
            style={modalStyle}>
            <Container className="t-create-screen-modal">
                <Header>
                    <Title><div>Create Idea</div></Title>
                    <CloseButtonContainer className="t-close-create-screen-button" onClick={doClose}>
                        <XButton>&times;</XButton>
                    </CloseButtonContainer>
                </Header>
                {iframe}
            </Container>
        </ReactModal>
    );
};

export default CreateIdeaModal;
